import { ChatThreadsListHeader as ChatThreadsListHeaderSkeleton } from "@circle-react-uikit/SkeletonLoader/skeletons/ChatThreadsListHeader";
import { ChatThreadsListPage as ChatThreadsListPageSkeleton } from "@circle-react-uikit/SkeletonLoader/skeletons/Messaging/ChatThreadsListPage";
import { lazyWithRetry } from "@circle-react/helpers/lazyRetry";
import { Suspense, type ComponentPropsWithoutRef } from "react";

const ChatThreadsList = lazyWithRetry(() =>
  import(/* webpackChunkName: "ChatThreadsList" */ "./ChatThreadsList").then(
    module => ({ default: module.ChatThreadsList }),
  ),
);

type LazyChatThreadsListProps = ComponentPropsWithoutRef<
  typeof ChatThreadsList
>;

/** Keeps emoji-js / Compass ReactionPicker off the initial shell graph. */
export const LazyChatThreadsList = ({
  isRenderedOnHeader = false,
  ...props
}: LazyChatThreadsListProps) => {
  const Fallback = isRenderedOnHeader
    ? ChatThreadsListHeaderSkeleton
    : ChatThreadsListPageSkeleton;

  return (
    <Suspense fallback={<Fallback />}>
      <ChatThreadsList isRenderedOnHeader={isRenderedOnHeader} {...props} />
    </Suspense>
  );
};
